var _circle, _path, _path2, _path3, _g, _path4, _rect, _path5, _path6, _path7, _mask, _path8, _path9, _path10, _path11, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFavoriteProducts = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 120 120"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 60,
  cy: 60,
  r: 60,
  fill: "#EBF2EF"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M65.995 40.602h7.306v50.466h-7.306V40.603Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#36485C",
  fillRule: "evenodd",
  stroke: "#36485C",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 0.28,
  d: "M25.385 40.64c0-.49.392-.887.876-.887h47.832c.484 0 .876.397.876.888v49.533c0 .49-.392.888-.876.888H30.466c-2.806 0-5.081-2.305-5.081-5.148V40.64Zm1.752.888v44.386c0 1.862 1.49 3.373 3.329 3.373h42.751V41.528h-46.08Z",
  clipRule: "evenodd"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#36485C",
  fillRule: "evenodd",
  stroke: "#36485C",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 0.28,
  d: "M73.245 40.64c0-.49.289-.887.645-.887h19.837c.356 0 .645.397.645.888v45.273c0 2.843-1.675 5.148-3.742 5.148H73.89c-.356 0-.645-.397-.645-.888V40.641Zm1.29.888v47.759H90.63c1.354 0 2.452-1.51 2.452-3.374V41.529H74.536Z",
  clipRule: "evenodd"
})), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#favorite-products_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#36485C",
  d: "M58.047 64.387v.066c0 .264-.398 5.798-7.262 8.301v-3.459l4.145-4.48a.992.992 0 0 0-.066-1.416 1.008 1.008 0 0 0-1.426.066l-2.653 2.899V63.366c.332-.758 1.923-3.722 5.836-3.722h.1c1.558 1.844 1.326 4.71 1.326 4.743Zm-9.252 1.977-2.685-2.9a.997.997 0 0 0-1.393-.065c-.398.362-.431 1.021-.066 1.416l4.144 4.48v3.426c-6.863-2.503-7.228-8.07-7.261-8.3v-.067c0-.033-.266-2.899 1.293-4.743h.133c3.945 0 5.504 2.997 5.835 3.722v3.031Zm9.12-8.433a1.124 1.124 0 0 0-.63-.297c-3.748-.23-6.202 1.68-7.495 3.46-1.293-1.78-3.714-3.69-7.494-3.46-.232 0-.464.132-.63.297-2.42 2.404-2.155 6.226-2.122 6.588 0 .263.166 2.141 1.393 4.315 1.16 2.076 3.614 4.81 8.489 6.193.033 0 .066 0 .066.033h.53c.034 0 .067 0 .1-.033 9.052-2.536 9.848-9.783 9.881-10.475.033-.198.365-4.15-2.089-6.621Z"
}))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#F6F9FC",
  d: "M18.778 67.541h13.28v2.525c1.21.437 3.634 1.999 3.634 4.745V92.18c.017.454-.262 1.363-1.514 1.363H16.809c-.471.017-1.414-.232-1.414-1.363V74.81c.085-1.178.879-3.776 3.383-4.746v-2.524Z"
})), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 16.46,
  height: 4.229,
  x: 17.237,
  y: 63.033,
  fill: "#fff",
  rx: 0.892
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#86B09B",
  d: "M19.677 80.421a6.445 6.445 0 0 1 6.445-6.444h9.52v19.318H19.677V80.42Z"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillOpacity: 0.35,
  d: "M31.081 73.977h4.561V93.52h-4.561z"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  stroke: "#36485C",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.667,
  d: "M32.062 70.135V67.58v0a1.84 1.84 0 0 0 1.839-1.84v-.848a2.148 2.148 0 0 0-2.149-2.148H19.195a2.148 2.148 0 0 0-2.148 2.148v.849a1.84 1.84 0 0 0 1.839 1.839v2.592a5.266 5.266 0 0 0-2.494 1.9 5.121 5.121 0 0 0-.945 2.959v16.278c0 1.187.962 2.149 2.149 2.149h15.868a2.148 2.148 0 0 0 2.148-2.149V75.033a5.122 5.122 0 0 0-.978-3.006 5.269 5.269 0 0 0-2.572-1.892ZM32.08 67.566H19.1"
})), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
  id: "favorite-products_svg__b",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M78.9 39.754a.5.5 0 0 0-.5.5v20.878a.5.5 0 0 0 .775.417l4.662-3.073a.5.5 0 0 1 .55 0l4.663 3.073a.5.5 0 0 0 .775-.417V40.254a.5.5 0 0 0-.5-.5H78.9Z",
  clipRule: "evenodd"
}))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  fill: "#B6CEC2",
  fillRule: "evenodd",
  d: "M78.9 39.754a.5.5 0 0 0-.5.5v20.878a.5.5 0 0 0 .775.417l4.662-3.073a.5.5 0 0 1 .55 0l4.663 3.073a.5.5 0 0 0 .775-.417V40.254a.5.5 0 0 0-.5-.5H78.9Z",
  clipRule: "evenodd"
})), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  fill: "#36485C",
  d: "m79.175 61.549-.918-1.392.918 1.392Zm4.662-3.073-.917-1.392.917 1.392Zm.55 0 .918-1.392-.917 1.392Zm4.663 3.073.918-1.392-.918 1.392Zm-8.984-21.295c0 .644-.522 1.167-1.167 1.167v-3.334c-1.196 0-2.166.97-2.166 2.167h3.333Zm0 20.878V40.254h-3.333v20.878h3.333Zm-1.809-.974a1.167 1.167 0 0 1 1.81.974h-3.334c0 1.725 1.918 2.758 3.359 1.809l-1.835-2.784Zm4.663-3.074-4.663 3.073 1.835 2.784 4.662-3.074-1.834-2.783Zm2.385 0a2.167 2.167 0 0 0-2.385 0l1.834 2.783c-.39.257-.894.257-1.284 0l1.835-2.783Zm4.662 3.073-4.662-3.073-1.835 2.783 4.663 3.074 1.835-2.784Zm-1.808.975c0-.93 1.033-1.486 1.808-.974l-1.834 2.783c1.44.95 3.36-.084 3.36-1.81h-3.334Zm0-20.878v20.878h3.333V40.254H88.16Zm1.166 1.167a1.167 1.167 0 0 1-1.166-1.167h3.333c0-1.197-.97-2.167-2.167-2.167v3.334Zm-10.426 0h10.426v-3.334H78.9v3.334Z",
  mask: "url(#favorite-products_svg__b)"
})), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
  fill: "#36485C",
  fillRule: "evenodd",
  stroke: "#36485C",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 0.28,
  d: "M88.142 27.902a.42.42 0 0 0-.298.124L76.03 39.892h17.206L104.46 28.62a.42.42 0 0 0-.298-.717h-16.02Zm-1.292-.865a1.823 1.823 0 0 1 1.292-.537h16.02c1.621 0 2.436 1.96 1.291 3.109l-11.429 11.48a.701.701 0 0 1-.496.206H74.343a.701.701 0 0 1-.497-1.196L86.85 27.037ZM14.536 29.609c-1.145-1.15-.33-3.109 1.291-3.109h16.02c.485 0 .95.194 1.292.538l12.81 12.82a.701.701 0 0 1-.995.988l-12.81-12.82a.42.42 0 0 0-.298-.124H15.827a.42.42 0 0 0-.298.717L26.958 40.1a.7.7 0 1 1-.993.99l-11.43-11.48Z",
  clipRule: "evenodd"
})), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
  fill: "#B6CEC2",
  stroke: "#36485C",
  strokeWidth: 1.667,
  d: "M79.419 40.518h9.685l12.914-13.253h-9.685L79.419 40.518Z"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "favorite-products_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M39.346 57.469h20.89v17.788h-20.89z"
})))));
export default SvgFavoriteProducts;